export const validateGroupField = (field, groupValues, t) => {
    if (!field.required) return null

    if (field.multiple) {
        // For multiple groups
        if (!Array.isArray(groupValues) || groupValues.length < (field.min || 1)) {
            return `${field.label} ${t('validation.is_required')}`
        }

        const groupErrors = {}
        let hasErrors = false

        groupValues.forEach((groupItem, index) => {
            const itemErrors = {}

            field.fields.forEach(subField => {
                // Only validate if the subfield is required
                if (subField.required) {
                    if (subField.type === 'multilang') {
                        // Check both English and Arabic for multilang
                        const enValue = groupItem?.[subField.name]
                        const arValue = groupItem?.[`${subField.name}_ar`]

                        if (!enValue || !enValue.toString().trim()) {
                            itemErrors[subField.name] = `${subField.label} (English) ${t(
                                'validation.is_required'
                            )}`
                        }
                        if (!arValue || !arValue.toString().trim()) {
                            itemErrors[`${subField.name}_ar`] = `${subField.label} ${t(
                                'validation.is_required_ar'
                            )} ${t('validation.is_required')}`
                        }
                    } else if (subField.type === 'number') {
                        // Special handling for number fields
                        const value = groupItem?.[subField.name]
                        // Check for undefined, null, empty string, or NaN
                        if (value === undefined || value === null || value === '' || isNaN(value)) {
                            itemErrors[subField.name] = `${subField.label} ${t(
                                'validation.is_required'
                            )}`
                        }
                    } else {
                        // Regular field
                        const value = groupItem?.[subField.name]
                        if (!value || (typeof value === 'string' && !value.trim())) {
                            itemErrors[subField.name] = `${subField.label} ${t(
                                'validation.is_required'
                            )}`
                        }
                    }
                }
            })

            if (Object.keys(itemErrors).length > 0) {
                groupErrors[index] = itemErrors
                hasErrors = true
            }
        })

        return hasErrors ? groupErrors : null
    } else {
        // For single group
        if (!groupValues) {
            return `${field.label} ${t('validation.is_required')}`
        }

        const errors = {}
        let hasErrors = false

        field.fields.forEach(subField => {
            // Only validate if the subfield is required
            if (subField.required) {
                if (subField.type === 'multilang') {
                    const enValue = groupValues?.[subField.name]
                    const arValue = groupValues?.[`${subField.name}_ar`]

                    if (!enValue || !enValue.toString().trim()) {
                        errors[subField.name] = `${subField.label} (English) ${t(
                            'validation.is_required'
                        )}`
                        hasErrors = true
                    }
                    if (!arValue || !arValue.toString().trim()) {
                        errors[`${subField.name}_ar`] = `${subField.label} ${t(
                            'validation.is_required_ar'
                        )} ${t('validation.is_required')}`
                        hasErrors = true
                    }
                } else if (subField.type === 'number') {
                    const value = groupValues?.[subField.name]
                    if (value === undefined || value === null || value === '' || isNaN(value)) {
                        errors[subField.name] = `${subField.label} ${t('validation.is_required')}`
                        hasErrors = true
                    }
                } else {
                    const value = groupValues?.[subField.name]
                    if (!value || (typeof value === 'string' && !value.trim())) {
                        errors[subField.name] = `${subField.label} ${t('validation.is_required')}`
                        hasErrors = true
                    }
                }
            }
        })

        return hasErrors ? errors : null
    }
}

// Update your validateFields function
export const validateFields = (fields, data, setErrors, t) => {
    const newErrors = {}

    fields.forEach(field => {
        if (field.type === 'group' && field.required) {
            const groupValue = data[field.name]
            const groupError = validateGroupField(field, groupValue, t)
            if (groupError) {
                newErrors[field.name] = groupError
            }
        } else if (field.type === 'multilang' && field.required) {
            const base = field.name
            const langErrors = {}

            if (!data[base] || !data[base].toString().trim()) {
                langErrors.en = `${field.label} (English) ${t('validation.is_required')}`
            }

            if (!data[`${base}_ar`] || !data[`${base}_ar`].toString().trim()) {
                langErrors.ar = `${field.label} ${t('validation.is_required_ar')} ${t(
                    'validation.is_required'
                )}`
            }

            if (Object.keys(langErrors).length > 0) {
                newErrors[base] = langErrors
            }
        } else if (field.required) {
            // ... existing regular field validation ...
            if (!data[field.name] || !data[field.name].toString().trim()) {
                newErrors[field.name] = `${field.label} ${t('validation.is_required')}`
            }
        }
    })

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
}
